import { Check, RotateCcw, RotateCw, Settings2 } from 'lucide-react';
import { Dropdown } from '../componentes/dropdown';
import { CONTROLE_BARRA } from '../componentes/ui';
import type { OpcaoColuna } from '../componentes/seletor-colunas';

/**
 * O menu "Mais opções" da consulta de sociedades: visão (lista/cards),
 * colunas e atualizar — os controles que só mudam a
 * APARÊNCIA, nunca o resultado da busca.
 *
 * O olho de esconder valores saiu daqui para a BARRA: é controle de
 * privacidade, e privacidade atrás de dois cliques não serve.
 *
 * Em arquivo à parte pelo mesmo motivo de `sociedades-resumo.tsx`: o teto de
 * linhas de `sociedades.tsx`, não peso próprio — ver a regra de chrome
 * colapsado em `pagina-shell.tsx`.
 */
export function MenuOpcoesSociedades({
  opcoesColunas,
  colunasOcultas,
  aoAlternarColuna,
  aoRestaurarColunas,
  atualizando,
  aoAtualizar,
}: {
  opcoesColunas: readonly OpcaoColuna[];
  colunasOcultas: readonly string[];
  aoAlternarColuna: (coluna: string) => void;
  aoRestaurarColunas: () => void;
  atualizando: boolean;
  aoAtualizar: () => void;
}) {
  const colunasVisiveis = opcoesColunas.length - colunasOcultas.length;

  return (
    <Dropdown
      rotulo="Mais opções"
      classeGatilho={`${CONTROLE_BARRA} w-11 justify-center`}
      gatilho={<Settings2 className="size-4" aria-hidden />}
      classePainel="w-64 p-1"
    >
      {(fechar) => (
        <>
          <p className="text-tinta-500 px-2 pt-1 pb-1 text-xs">
            {colunasVisiveis} de {opcoesColunas.length} colunas
          </p>
          {opcoesColunas.map((opcao) => {
            const escondida = colunasOcultas.includes(opcao.chave);
            const ultima = !escondida && colunasVisiveis === 1;
            return (
              <button
                key={opcao.chave}
                type="button"
                disabled={ultima}
                title={ultima ? 'A tabela precisa de pelo menos uma coluna.' : undefined}
                onClick={() => aoAlternarColuna(opcao.chave)}
                className="text-tinta-700 hover:bg-marca-600/[0.07] flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-40"
              >
                <span className="flex size-4 shrink-0 items-center justify-center">
                  {!escondida && (
                    <Check className="text-marca-600 size-3.5" aria-hidden />
                  )}
                </span>
                <span className="min-w-0 flex-1 truncate">{opcao.titulo}</span>
              </button>
            );
          })}
          {colunasOcultas.length > 0 && (
            <button
              type="button"
              onClick={aoRestaurarColunas}
              className="text-tinta-700 hover:bg-marca-600/[0.07] border-tinta-100 mt-1 flex w-full items-center gap-2 rounded-md border-t px-2 py-1.5 text-left text-sm transition-colors"
            >
              <RotateCcw className="size-3.5" aria-hidden />
              Mostrar todas
            </button>
          )}

          <div className="border-tinta-100 my-1 border-t" />
          <button
            type="button"
            onClick={() => {
              aoAtualizar();
              fechar();
            }}
            className="text-tinta-700 hover:bg-marca-600/[0.07] flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm transition-colors"
          >
            <RotateCw
              className={`size-4 ${atualizando ? 'animate-spin' : ''}`}
              aria-hidden
            />
            Atualizar
          </button>
        </>
      )}
    </Dropdown>
  );
}
